import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAppStore } from 'app/app-store'

export const useRouteTracker = (): void => {
    const location = useLocation()
    const { setLastRecordedRoute } = useAppStore()

    useEffect(() => {
        const currentPath = location.pathname
        setLastRecordedRoute(currentPath)
    }, [location.pathname, setLastRecordedRoute])
}
